import React from 'react';
import { useHistory } from 'react-router';
import { Button, SkeletonLoading } from '@saleshandy/design-system';
import { ChevronLeft, Pencil } from '@saleshandy/icons';

import { accessibleOnClick } from '../../../../../../../../shared/utils/accessible-on-click';
import TruncatedTextWithTooltip from '../../../../../../../../shared/components/truncated-text-with-tooltip';
import { GlobalSettings } from '../../../../../../../../shared/components/global-settings-wrapper';
import hasPermission from '../../../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../../../shared/utils/access-control/enums/permissions';

type IProps = {
  listName: string;
  totalCount: number;
  subtitle: string;
  isLoading: boolean;
  onEdit: VoidFunction;
  onAddPhoneNumber: VoidFunction;
  onShowImportModal: VoidFunction;
};

const DoNotCallListDetailsHeader: React.FC<IProps> = ({
  listName,
  totalCount,
  subtitle,
  isLoading,
  onEdit,
  onAddPhoneNumber,
  onShowImportModal,
}) => {
  const history = useHistory();

  return (
    <GlobalSettings.Header className="do-not-contact-list-details--header">
      <GlobalSettings.HeaderLeft>
        <div
          className="go-back-btn"
          {...accessibleOnClick(() => {
            history.push(`/settings/call-dnc-list`);
          })}
        >
          <ChevronLeft />
        </div>

        <div className="list-details">
          {isLoading ? (
            <div className="skeleton-loader">
              <SkeletonLoading width={200} height={20} />
            </div>
          ) : (
            <>
              <div className="list-details-inner">
                <TruncatedTextWithTooltip
                  length={50}
                  string={listName}
                  textClassName="list-name"
                  tooltipClassName="tooltip-xxl"
                />

                <div className="do-not-contact-list-details-popover-badge">
                  <span>{totalCount}</span>
                </div>

                {hasPermission(Permissions.DNC_WRITE) && (
                  <div className="edit-list-btn" {...accessibleOnClick(onEdit)}>
                    <Pencil />
                  </div>
                )}
              </div>
              {subtitle && (
                <p className="regular-2 gray-txt-11 mt-1 mb-0">{subtitle}</p>
              )}
            </>
          )}
        </div>
      </GlobalSettings.HeaderLeft>
      <GlobalSettings.HeaderRight>
        {hasPermission(Permissions.DNC_LIST_WRITE) && (
          <>
            <Button {...accessibleOnClick(() => onShowImportModal())} variant="secondary">
              Upload CSV
            </Button>
            <Button {...accessibleOnClick(() => onAddPhoneNumber())}>Add Phone Number</Button>
          </>
        )}
      </GlobalSettings.HeaderRight>
    </GlobalSettings.Header>
  );
};

export default DoNotCallListDetailsHeader;
